<template>
	<div class="SaveView" :class="{
		'SaveView--fixed': fixed,
		'SaveView--gray': gray,
		visible: show,
		saved: saved,
	}">
		<div v-if="fixed">
			<div class="SaveViewButtons">
				<div class="SaveViewButtons-box">
					<button class="SaveViewSave" @click.prevent="$emit('save')" :disabled="saving">
						<span v-show="!saving">Сохранить изменения</span>
						<vue-loading class="SaveViewLoader" type="spin" color="white"
							:size="{ width: '30px', height: '30px' }" v-show="saving" />
					</button>
					<button class="SaveViewCancel" @click.prevent="checkCancel()" :disabled="saving">
						<span>Не сохранять</span>
					</button>
				</div>
			</div>
			<div class="SaveViewSaved">
				Your changes have been saved, and are now live on the site.
			</div>
		</div>
	</div>
</template>

<script>
import { VueLoading } from "vue-loading-template";

export default {
	name: "SaveView",
	components: {
		VueLoading,
	},
	props: {
		show: Boolean,
		dirty: { type: Boolean, default: true },
		fixed: { type: Boolean, default: true },
		prompt_cancel: { type: Boolean, default: true },
		gray: { type: Boolean, default: false },
		saving: { type: Boolean, default: false },
	},
	data() {
		return {
			timer: undefined,
			saved: false,
		};
	},
	watch: {
		saving: {
			handler(n) {
				if (n === false && this.show === false) {
					this.saved = true;
					this.timer = setTimeout(this.hideSaved, 2000);
				}
			}
		},
	},
	computed: {
		isActive() {
			return this.$route.params.id === undefined
				? this.$route.name
				: this.$route.params.id;
		},

		isName() {
			return this.$route.name;
		},
	},
	methods: {
		checkCancel() {
			if (
				!this.prompt_cancel ||
				!this.dirty ||
				confirm("Are you sure want to cancel?")
			) {
				this.$emit("cancel");
			}
		},
		beforeDestroy() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.saved = false;
			}
		},
	},
};
</script>

<style lang="less">
@import "~styles/const.less";
@import "~styles/styles.less";

.SaveView {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 19px 0 20px 40px;
	text-align: center;
	z-index: 100;
	transition: transform 0.3s;
	transform: translateY(100px);
	font-family: @Graphik-LCG;
	height: 82px;

	&Saved {
		display: none;
		position: absolute;
		left: 0;
		right: 0;
		height: 30px;
		bottom: 100px;
		color: black;
		text-align: center;
		letter-spacing: 0;
		transition: transform 0.3s;
		transform: translateY(30px);
	}

	&Past {
		padding: 22px 45px 22px 56px !important;
	}

	&Delete {
		padding: 22px 82px 22px 64px !important;
		border-left: 1px solid @color-border-gray;

		>svg {
			fill: @color-red;
		}

		&.new {
			opacity: 0;
			pointer-events: none;
		}
	}

	&Hide {
		border-left: 1px #979797 solid;
	}

	&--fixed {
		position: fixed;
		text-align: left;
		border: none;
		font-size: 0;
		padding: 0;
		bottom: -100px;
		transition: all 0.3s;
		transform: unset;
		color: black;

		.SaveViewButtons {
			display: flex;
			justify-content: flex-end;
			padding: 0;
			position: relative;
			transition: transform 0.3s;
			transform: translateY(100px);
			margin: 11px auto;
			height: 100%;
			padding-right: 20px;

			&-box {
				display: flex;

				>button {
					position: relative;
					width: auto;
					font-size: 12px;
					line-height: 16px;
					padding: 12px 15px;
					cursor: pointer;
					transition: opacity .3s ease;
					height: 40px;
					border: 1px solid black;

					&:hover {
						opacity: .6;
					}

					&.SaveViewSave {
						background-color: black;
						color: white;
						white-space: nowrap;
						min-width: 160px;
					}

					&.SaveViewCancel {
						background-color: white;
						color: black;
					}
				}
			}
		}

		.SaveViewCancel {
			margin: 0;
		}
	}

	&.visible {
		transform: none;
		bottom: 0;
	}

	&--fixed.visible &Buttons {
		transform: none;
	}

	&--fixed.saved &Saved {
		transform: none;
	}
}

.SaveViewCancel {
	margin-right: 63px;
}

.SaveViewLoader {
	position: absolute !important;
	top: 5px;
	left: 64px;
}

.svg--oval {
	width: 8px;
	height: 8px;
	margin-right: 10px;
	fill: @color-white;
}
</style>
